import { AbstractService } from '@/services/core/serviceFactory';

export interface TransferPatient {
  id?: number;
  transfer_id?: number;
  pep_patient_clinic_data_id?: number;
  patient_name?: string;
  assigned_cs_id?: number | null;
}

export class TransferPatientsService extends AbstractService {
  /**
   * Accept a patient transfer
   */
  async acceptTransfer(transferId: number, userId: number): Promise<any> {
    console.log('🔧 TransferPatientsService.acceptTransfer called with:', { transferId, userId });
    console.log('🔐 Service context:', this.context);
    
    this.requireAuth();

    if (!transferId || !userId) {
      console.error('❌ Missing required parameters:', { transferId, userId });
      throw new Error('Transfer ID and User ID are required');
    }

    console.log('✅ TransferPatientsService - accepting transfer:', {
      transferId,
      userId,
      hasToken: !!this.context.token,
      hasuraToken: !!this.context.hasuraToken
    });

    try {
      // Use apiClient for REST API calls following the three-layer architecture pattern
      const endpoint = `/api/ngpep/${userId}/acceptTransfer/${transferId}`;
      console.log('🌐 Making API call to:', endpoint);
      console.log('🔑 Using token:', this.context.token ? 'Present' : 'Missing');
      
      const response = await this.apiClient.post(endpoint, { assignedUserName: ' ' }, this.context.token);
      
      console.log('📋 TransferPatientsService - API Response:', response);
      console.log('📊 Response data:', response.data);
      console.log('✅ Response success:', response.success);
      
      return { ok: response.success, ...response.data };
    } catch (error) {
      console.error('❌ Error in TransferPatientsService.acceptTransfer:', error);
      throw new Error('Failed to accept patient transfer');
    }
  }

  /**
   * Accept transfer with retry logic for different patient IDs
   */
  async acceptTransferWithRetry(patient: TransferPatient, userId: number): Promise<boolean> {
    console.log('🔄 TransferPatientsService.acceptTransferWithRetry called');
    this.requireAuth();

    // Use transfer_id from the view (pep_vw_patient_user_transfer)
    const transferId = patient.transfer_id;
    
    if (!transferId) {
      console.error('❌ No valid transfer ID found in patient object:', patient);
      throw new Error('No valid transfer ID found');
    }

    console.log('✅ TransferPatientsService - attempting transfer acceptance:', {
      transferId: transferId,
      patient_name: patient.patient_name,
      userId: userId
    });

    try {
      console.log('🎯 Calling acceptTransfer with transferId:', transferId);
      const response = await this.acceptTransfer(transferId, userId);
      console.log('📋 acceptTransfer response:', response);
      
      if (response.ok) {
        console.log('✅ Transfer accepted successfully');
        return true;
      }

      console.error('❌ Transfer acceptance failed');
      throw new Error(`Failed to accept transfer with ID ${transferId}`);
      
    } catch (error) {
      console.error('❌ Error in TransferPatientsService.acceptTransferWithRetry:', error);
      throw error;
    }
  }
}